export function isEmbeddedBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /FBAN|FBAV|Twitter|Instagram/i.test(ua);
}

export function openInSystemBrowser(url: string): void {
  window.open(url, '_blank');
}
